import { Pipe, PipeTransform } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({
    name: 'imageContentSafeImageUrl',
    standalone: false
})
export class ImageContentSafeImageUrlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {
  }

  //used in image widget to bypass sanitization of image url
  transform(value: string, ...args: unknown[]): unknown {
    return this.sanitizer.bypassSecurityTrustUrl(value);
  }
}
